"use client";

import * as React from "react";

import { cn } from "../utils/mergeClassNames";
import { Input } from "./input";

interface TimePickerProps {
  value?: Date;
  onChange?: (date: Date) => void;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
}

function TimePicker({
  value,
  onChange,
  placeholder = "Pick a time",
  className,
  disabled,
}: TimePickerProps) {
  // Format time as HH:mm:ss for the input
  const formatTime = (date?: Date) => {
    if (!date) return "";
    return date.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });
  };

  const handleTimeChange = (timeString: string) => {
    if (!onChange) return;

    const [hours, minutes, seconds] = timeString.split(":").map(Number);
    if (
      hours === undefined ||
      minutes === undefined ||
      Number.isNaN(hours) ||
      Number.isNaN(minutes)
    ) {
      return;
    }

    const newDate = value ? new Date(value) : new Date();
    newDate.setHours(hours);
    newDate.setMinutes(minutes);
    newDate.setSeconds(
      seconds !== undefined && !Number.isNaN(seconds) ? seconds : 0,
    );

    onChange(newDate);
  };

  return (
    <Input
      type="time"
      step="1"
      value={formatTime(value)}
      onChange={(e) => handleTimeChange(e.target.value)}
      placeholder={placeholder}
      disabled={disabled}
      className={cn(
        "w-32 appearance-none bg-background font-normal [&::-webkit-calendar-picker-indicator]:hidden [&::-webkit-calendar-picker-indicator]:appearance-none",
        className,
      )}
    />
  );
}

export { TimePicker };
export type { TimePickerProps };
